import { MoreHoriz } from '@mui/icons-material';
import { Box, Button, Menu } from '@mui/material';
import React, { useCallback, useMemo, useState } from 'react';

const ActionsMenu =
    React.memo(({ children, button, icon, anchorVertical, transformVertical, anchorHorizontal, transformHorizontal, iconLeft, disabled, sizeButton }) => {
        const [openMenuList, setOpenMenuList] = useState(null);
        const open = Boolean(openMenuList);

        const handleOpenMenuList = useCallback((event) => {
            setOpenMenuList(event.currentTarget);
        }, [setOpenMenuList])

        const handleCloseMenuList = useCallback(() => {
            setOpenMenuList(null);
        }, [setOpenMenuList]);
        const anchorOrigin = useMemo(() => ({ vertical: anchorVertical || "bottom", horizontal: anchorHorizontal || "left" }), [anchorHorizontal, anchorVertical])
        const transformOrigin = useMemo(() => ({ vertical: transformVertical || "top", horizontal: transformHorizontal || "left" }), [transformVertical, transformHorizontal])

        return (
            <>
                {iconLeft ? (
                    <MoreHoriz onClick={handleOpenMenuList} style={{ cursor: "pointer" }} />
                ) : (
                    (<>
                        {button ? (
                            button({ onClick: handleOpenMenuList })
                        ) : (
                            <Button
                                disabled={disabled}
                                data-fit-content
                                size={sizeButton}
                                variant="outlined"
                                primary
                                data-whitebg
                                onClick={handleOpenMenuList}
                            >
                                Menu
                            </Button>
                        )
                        }
                    </>
                    )
                )}
                <Menu
                    anchorEl={openMenuList}
                    getContentAnchorEl={null}
                    anchorOrigin={anchorOrigin}
                    transformOrigin={transformOrigin}
                    open={open}
                    onClose={handleCloseMenuList}
                >
                    <Box onClick={handleCloseMenuList}>{children}</Box>
                </Menu>
            </>
        );
    });

export default ActionsMenu;
